import { render, staticRenderFns } from "./subscription-plan.component.vue?vue&type=template&id=0263c97f&scoped=true"
import script from "./subscription-plan.component.ts?vue&type=script&lang=ts&external"
export * from "./subscription-plan.component.ts?vue&type=script&lang=ts&external"
import style0 from "./subscription-plan.component.vue?vue&type=style&index=0&id=0263c97f&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0263c97f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0263c97f')) {
      api.createRecord('0263c97f', component.options)
    } else {
      api.reload('0263c97f', component.options)
    }
    module.hot.accept("./subscription-plan.component.vue?vue&type=template&id=0263c97f&scoped=true", function () {
      api.rerender('0263c97f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/payment/subscription-plan/subscription-plan.component.vue"
export default component.exports